<style>
  .bottomsheet_bottomImage img {
    width: 10rem;
    position: absolute;
    right: 0px;
    top: 620px;
  }
  .nav-img{
    mix-blend-mode: overlay;
    z-index: 1;
  }
</style>
<mat-nav-list>
  <div fxHide="true" fxLayout="column" fxShow.lt-sm="true" fxLayoutAlign="space-around end" #navbar>
    <div class="cross">
      <i class="fa fa-times" (click)="openLink($event)"></i>
    </div>
  </div>
  <div fxHide="true" fxLayout="column" fxShow.lt-sm="true" class="mobile" fxLayoutAlign="space-evenly start" #navbar>
    <img src="../../../assets/images/BANCOM-header-logo.png" width="80px" style="padding: 14px 15px" />
    <div>
      <div class="flex_menu" fxLayout="column" fxLayoutAlign="space-evenly start">
        <button mat-button (click)="openLink($event)" routerLink="/home">
          <span class="bold" style="padding-left: 15px; color: #f8f8f8">
            Home
          </span>
        </button>
        <button mat-button (click)="openLink($event)" routerLink="/login">
          <span class="bold" style="padding-left: 15px; color: #f8f8f8" >
            Login
          </span><span class="icons"></span>
        </button>

        <button mat-button>
          <span class="bold" style="border-bottom: 1px solid #0fa863; color: #f8f8f8">For Individual</span><span
            class="icons">
            <!-- <i class="fa fa-chevron-down"></i> -->
          
          </span>
        </button>
        <button mat-button (click)="openLink($event)" routerLink="/individual-placements">
          <span class="bold"> Placement</span>
        </button>
        <button mat-button (click)="openLink($event)" routerLink="/individual-programs/overview">
          <span class="bold"> Trainings</span><span class="icons"><i class="fa fa-chevron-down"></i></span>
        </button>
        <div fxLayout="row wrap" fxLayoutGap="3%" (click)="openLink($event)">
          <button mat-menu-item fxFlex="45" routerLink="/individual-programs/vlocity-program">
            Vlocity Developer<br />
            Track
          </button>
          <button mat-menu-item fxFlex="45" routerLink="/individual-programs/mulesoft-program">
            Mule Soft
          </button>
          <button mat-menu-item fxFlex="45" routerLink="/individual-programs/marketing-cloud-program">
            Marketing Cloud
          </button>
          <button mat-menu-item fxFlex="45" routerLink="/individual-programs/service-cloud">
            Service Cloud
          </button>
          <button mat-menu-item fxFlex="45" routerLink="/individual-programs/sales-cloud">
            Sales Cloud
          </button>
          <button mat-menu-item fxFlex="45" routerLink="/individual-programs/health-cloud">
            Health Cloud
          </button>
          <button mat-menu-item fxFlex="50" routerLink="/individual-programs/sf-admin-program">
            Salesforce Administration <br />Track
          </button>
          <button mat-menu-item fxFlex="50" routerLink="/individual-programs/sf-developer-program">
            Salesforce Developer<br />
            Track
          </button>
        </div>
        <!--<button mat-button>
          <span class="bold" style="border-bottom: 1px solid #4d8c70; color: #f8f8f8">For Corporates</span><span
            class="icons">
            <!-- <i class="fa fa-chevron-down"></i> 
          </span>
        </button>
        <button mat-button (click)="openLink($event)">
          <span class="bold" routerLink="/corporate-hirings">Hiring</span>
        </button>
        <button mat-button (click)="openLink($event)" routerLink="/corporate-programs/overview">
          <span class="bold">Trainings</span><span class="icons"><i class="fa fa-chevron-down"></i></span>
        </button>
      
        <div fxLayout="row wrap" fxLayoutGap="3%" (click)="openLink($event)">
          <button mat-menu-item fxFlex="45" routerLink="/corporate-programs/vlocity-program">
            Vlocity Developer<br />
            Track
          </button>
          <button mat-menu-item fxFlex="45" routerLink="/corporate-programs/mulesoft-program">
            Mule Soft
          </button>
          <button mat-menu-item fxFlex="45" routerLink="/corporate-programs/marketing-cloud">
            Marketing Cloud
          </button>
          <button mat-menu-item fxFlex="45" routerLink="/corporate-programs/service-cloud">
            Service Cloud
          </button>
          <button mat-menu-item fxFlex="45" routerLink="/corporate-programs/sales-cloud">
            Sales Cloud
          </button>
          <button mat-menu-item fxFlex="45" routerLink="/corporate-programs/health-cloud">
            Health Cloud
          </button>
          <button mat-menu-item fxFlex="50" routerLink="/corporate-programs/sf-admin-program">
            Salesforce Administration <br />Track
          </button>
          <button mat-menu-item fxFlex="50" routerLink="/corporate-programs/sf-developer-program">
            Salesforce Developer<br />
            Track
          </button>
        </div>
        <!-- <div class="bottomsheet_bottomImage">
          <img class="nav-img" src="../../../assets/images/Bancom-Salesforce-Training-Menu.png" alt="BANCOM Salesforce Training Menu" />
        </div> -->
      </div>
    </div>
    <div class="bottomsheet_bottomImage">
      <img class="nav-img" src="../../../assets/images/Bancom-Salesforce-Training-Menu.png" alt="BANCOM Salesforce Training Menu" />
    </div>
  </div>
</mat-nav-list>